import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

import Tooltip from '@material-ui/core/Tooltip';

import { parseQueryString } from '../Utils/GlobalUtils';
import { loginRedirect, exchangeCode } from '../redux/auth';
import { login, logout } from '../redux/actions/userActions';

import { openErrorSnackBar } from '../redux/actions/snackBarActions';
import { logAndReturnErrorMsg } from '../Utils/ErrorLog';

const useStyles = makeStyles((theme) => ({
	icon: { color: 'white' },
}));

function extractAndParseQueryString(location) {
	return {
		...parseQueryString(location.search),
		...parseQueryString(window.location.search),
	};
}

export default function SignInButton(props) {
	const history = useHistory();
	const location = useLocation();
	const dispatch = useDispatch();
	const classes = useStyles();
	const token = useSelector((state) => state?.user?.token?.id_token);

	const { code, state, from } = extractAndParseQueryString(location);

	useEffect(() => {
		if (code) {
			exchangeCode(code)
				.then((token) => dispatch(login(token)))
				.then(() => {
					// Manually remove the `code` query param
					window.history.replaceState({}, '', window.location.pathname + window.location.hash);
					if (state) {
						// Encoded path includes a hash, which React Router adds for us
						const path = decodeURIComponent(state).split('#').pop() || '/';
						history.replace(path);
					} else {
						history.replace('/');
					}
				})
				.catch((e) => dispatch(openErrorSnackBar(logAndReturnErrorMsg(e, ''))));
		}
	}, [history, dispatch, code, state]);

	if (token) {
		return (
			<Tooltip title="Logout" aria-label="logout" placement="bottom">
				<IconButton
					className={classes.icon}
					key="sign-out-button"
					onClick={(e) => {
						e.preventDefault();
						dispatch(logout(null));
						history.push('/');
					}}
				>
					<LogoutIcon />
				</IconButton>
			</Tooltip>
		);
	}

	return (
		<Tooltip title="Login" aria-label="login" placement="bottom">
			<IconButton
				className={classes.icon}
				key="sign-in-button"
				onClick={(e) => {
					e.preventDefault();
					loginRedirect(false, from);
				}}
				title=""
			>
				<LockOutlinedIcon />
			</IconButton>
		</Tooltip>
	);
}
